jQuery(function ($) {
      $('.main_wrapper a[href^="#"], .sp_content a[href^="#"]').not('.header__btn-wishlist').click(function () {
    var buffer = $(".header").outerHeight(),
      a = $(this).attr("href"),
      e = $("#" == a || "" == a ? "html" : a).offset().top - 0;
    return $("body,html").animate({
      scrollTop: e
    }, 400, "swing"), !1
  })
      $('.best_seller_wrap a[href^="#"]').not('.header__btn-wishlist').click(function () {
    var buffer = $(".header").outerHeight(),
      a = $(this).attr("href"),
      e = $("#" == a || "" == a ? "html" : a).offset().top - 0;
    return $("body,html").animate({
      scrollTop: e
    }, 400, "swing"), !1
  })
});
jQuery(function($){
　　$('.product-collection__wrapper').matchHeight();
　　$('.blog-body .post').matchHeight();
　　$('.shop_list dl').matchHeight();
　　$('.tea101_mike .d-flex.flex-column.mt-15').matchHeight();
});